/**
 * 邀请短链落地页：/r/<6 位邀请码> → /register?invite=<邀请码>
 * 这里只做跳转，注册弹窗会从 query 读取邀请码并自动填入。
 */

import { Navigate, useParams } from 'react-router-dom';

export default function InviteLinkRedirect() {
  const { code } = useParams();

  if (!code) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/register?invite=${encodeURIComponent(code)}`} replace />;
}
